// Components
// Hooks
import { useKeyActions } from '@/utils/hooks/homeKeyActions/useKeyActions';
import useUserRole from '@/utils/hooks/user/useUserRole';

import { classNames } from '@/utils';

import { ActionItem } from '@/components/pages/home/keyActions/actionItem';

import { DualActionsItem } from './dualActionsItem';

export const HomeKeyActions = () => {
    const actionsCatalog = useKeyActions();
    const { isTeamMember } = useUserRole();

    return (
        <div
            data-testid="dashboard-actions"
            className={classNames(
                'mt-8 grid w-full grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3',
                {
                    'lg:grid-cols-4': !isTeamMember
                }
            )}>
            {actionsCatalog.map((action) =>
                action.is_dual === true ? (
                    <DualActionsItem
                        key={action.type}
                        is_displayed={action.is_displayed}
                        actions={action.actions}
                    />
                ) : (
                    <ActionItem key={action.type} action={action} />
                )
            )}
        </div>
    );
};
